class PubmedEntry {
  constructor(entry) {
    const data = entry?.json_data || {};
    const pubmedRef = (entry?.pub_med_references || [])[0];

    this.id = entry?.id;
    this.pubmedId = String(entry?.pub_med_id || pubmedRef || "");
    this.groupedVariants = entry?.groupedVariants || [];

    this.comment = data.comment;
    this.isFunctional = data.confirmedByFunctionalStudy;
    this.coAuthor = data.coAuthor;
    this.agreeContact = data.agreeContact;

    this.variants = data.variants || [];
    this.diseases = data.diseases || [];
    this.phenotypes = data.phenotypes || [];

    this.userOrganisation = data.userOrganisation;
    this.active = data.active;
    this.organisationId = data.organisation_id;
    this.user = data.user;
  }

  toJson() {
    return {
      id: this.id,
      pub_med_id: this.pubmedId,
      groupedVariants: this.groupedVariants,
      json_data: {
        comment: this.comment,
        confirmedByFunctionalStudy: this.isFunctional,
        coAuthor: this.coAuthor,
        agreeContact: this.agreeContact,
        variants: this.variants,
        diseases: this.diseases,
        phenotypes: this.phenotypes,
        userOrganisation: this.userOrganisation,
        active: this.active,
        organisation_id: this.organisationId,
        user: this.user,
      },
    };
  }

  normalizeForApi() {
    const getVal = (x) => (x ? x.value : "");
    const selectedVariants = this.groupedVariants.filter((v) => v.checked);

    const hg19Vars = selectedVariants
      .map((x) => ({ ...x, pathogenicity: x.pathogenicity.value }))
      .map((x) => ({ ...x, additional_info: x.additional_info.map(getVal) }))
      .map((x) => ({ ...x, variant_id: x.hg19.variant_id }));

    const hg38Vars = selectedVariants
      .map((x) => ({ ...x, pathogenicity: x.pathogenicity.value }))
      .map((x) => ({ ...x, additional_info: x.additional_info.map(getVal) }))
      .map((x) => ({ ...x, variant_id: x.hg38.variant_id }));

    this.variants = hg19Vars.concat(hg38Vars);
    this.phenotypes = this.phenotypes.filter((p) => p.checked);
    this.diseases = this.diseases
      .map((x) => ({ ...x, phenotypes: x.phenotypes.filter((p) => p.checked) }))
      .filter((x) => x.checked);

    return { ...this.toJson(), groupedVariants: undefined };
  }

  addDisease(disease) {
    this.diseases = [disease, ...this.diseases];
    return this;
  }

  addPhenotype(phenotype) {
    this.phenotypes = [phenotype, ...this.phenotypes];
    return this;
  }

  clone() {
    return new PubmedEntry(this.toJson());
  }
}

export default PubmedEntry;
